import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import RemoteHeader from "@xo-union/tk-component-header-nav/remote";
import HeaderNavWithModal from "../HeaderNavWithModal/index.js";
var renderHeaderNav = function renderHeaderNav(headerProps) {
  return /*#__PURE__*/React.createElement(RemoteHeader, headerProps);
};
var RemoteHeaderNav = function RemoteHeaderNav(props) {
  return /*#__PURE__*/React.createElement(HeaderNavWithModal, _extends({
    renderHeaderNav: renderHeaderNav
  }, props));
};
export default RemoteHeaderNav;